module.exports = __webpack_public_path__ + "static/media/confetti.11787b5a.png";